import { FeatureFlags, useFeatureFlags } from '@/helper/FeatureFlags';
import { useUserContext } from '@/modules/auth/hooks/useUser';
import { useAdminRoute } from '@/pages/corporate/routes/hooks/useAdminRoutes';

import { isFaceVerificationNeeded } from './utils';

export default function useIsFaceVerificationNeeded() {
  const user = useUserContext();
  const isAdmin = useAdminRoute();
  const { [FeatureFlags.EnableFaceVerification]: enableFaceVerification } = useFeatureFlags();

  const { federationId, uniqueId } = user;
  const userUniqueId = federationId ?? uniqueId;

  const isNeeded = isFaceVerificationNeeded({ userUniqueId, isAdmin, enableFaceVerification });

  return isNeeded;
}
